import { CalendarFold } from 'lucide-react'
import { useState } from 'react'

import ComboboxMultiSelectFilter, {
  type ComboboxFilterOption,
} from '../../reusable/table/ComboboxMultiSelectFilter'
import { type MultipleSelectedValuesFilter } from '../types'
import FilterManagementDropdown from './FilterManagementDropdown'
import { filterByLabelAndValueCallback } from './utils'

const PlanYearFilter = (props: MultipleSelectedValuesFilter) => {
  const [query, setQuery] = useState('')

  const planYearOptions: ComboboxFilterOption<string>[] = [
    // TODO: Figure out a better way to generate plan year options to look forward during OEP.
    { label: '2026', value: '2026' },
    { label: '2025', value: '2025' },
    { label: '2024', value: '2024' },
    { label: '2023', value: '2023' },
  ]

  const filteredOptions = planYearOptions?.filter(
    filterByLabelAndValueCallback(query)
  )

  return (
    <div>
      <ComboboxMultiSelectFilter
        {...props}
        options={[{ groupLabel: 'Plan years', options: filteredOptions || [] }]}
        placeholder='Search plan years to filter...'
        onValueChange={setQuery}
      >
        <FilterManagementDropdown
          {...props}
          options={planYearOptions || []}
          noSelectionText='Plan Year'
          pluralIdentifier='plan years'
        >
          <CalendarFold size={20} />
        </FilterManagementDropdown>
      </ComboboxMultiSelectFilter>
    </div>
  )
}

export default PlanYearFilter
